import type { Material } from 'three';
import { Group } from 'three';

import type { BaseObjectUserData } from 'shared/object3d/interfaces';
import { Object3DType } from 'shared/object3d/interfaces';
import type { SphereItemType } from 'shared/interfaces/planogram';
import { traverseObject3DMaterials } from 'shared/utils/three-utils';

export default class BaseObject3D<
  UserData extends BaseObjectUserData = BaseObjectUserData
> extends Group {
  itemType: SphereItemType;

  userData: UserData = {
    objectType: Object3DType.CANVAS_OBJECT,
  } as UserData;

  overrideOpacity(opacity: number) {
    traverseObject3DMaterials(this, (material: Material) => {
      if (material.userData.tempOpacityApplied === true) return;
      material.userData.originalOpacity = material.opacity;
      material.opacity = opacity;
      material.userData.tempOpacityApplied = true;
    });
  }

  resetOpacity() {
    traverseObject3DMaterials(this, material => {
      if (material.userData.tempOpacityApplied === true) {
        material.opacity = material.userData.originalOpacity;
        material.userData.tempOpacityApplied = false;
      }
    });
  }
}
